// @ts-strict-ignore
/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService implements OnDestroy {
  private storageSub = new Subject<string>();

  public ngOnDestroy(): void {
    this.storageSub.unsubscribe();
  }

  public set(key: string, value: string): void {
    sessionStorage.setItem(key, value);
    this.storageSub.next('added');
  }

  public get(key: string): string {
    return sessionStorage.getItem(key);
  }

  public remove(key: string): void {
    sessionStorage.removeItem(key);
    this.storageSub.next('removed');
  }

  public watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }
}
